﻿
$(function () {
    var modal = $(".lm__modal-alert");
    var containerData = modal.find(".lm__modal-dialog");

    var agreementData = function () {
        var modal = $(".lm__modal-alert");
        var closeModal = modal.find(".modal-close");
        var loadingIcon = modal.find(".loader-wrapper");
        var confirm = modal.find(".success-confirm");

        var closeModalAlert = function () {
            modal.fadeOut(function () {
                containerData.find(".modal-header-title").closest(".modal-injected-content").remove();
            });

            loadingIcon.fadeIn();

            return false;
        };

        var addEvents = function () {
            modal.bind("click", closeModalAlert);
            containerData.bind("click", function (event) { event.preventDefault(); return false; });
            closeModal.bind("click", closeModalAlert);
            confirm.bind("click", closeModalAlert);
        };

        return {
            init: function () {
                addEvents();
                return true;
            }
        };
    };

    function bindData(data) {
        var loadingIcon = modal.find(".loader-wrapper");
        $(".modal-content-wrapper").prepend(data);
        loadingIcon.fadeOut();
    }

    function getUrlParameter(sParam) {
        var sPageUrl = window.location.search.substring(1);
        var sUrlVariables = sPageUrl.split("&");
        for (var i = 0; i < sUrlVariables.length; i++) {
            var sParameterName = sUrlVariables[i].split("=");
            if (sParameterName[0] === sParam) {
                return sParameterName[1];
            }
        }
        return '';
    }

    $(document).ready(function () {
        var requests = [];
        // enhance table saw to make responsive table
        $(document).trigger("enhance.tablesaw");

        var ad = new agreementData();
        ad.init();

        // Load other tabs/Agreements in the background when page is loaded.
        if ($(".my-agreements-overview").length) {
            var tab = getUrlParameter("tab");
            var customerNumber = $("#CurrentCustomerNumber").val();
            var customerNumberUrlParameter = getUrlParameter("customerNumber"); // if customer number is coming in url use that
            if (customerNumberUrlParameter != '' && customerNumberUrlParameter.length > 0) {
                customerNumber = customerNumberUrlParameter;
            }
            
            if (customerNumber) {
				var currentPageId = $("#CurrentPageId").val();
	            var forageUrl = customerNumber.length > 0 ? "/api/myagreements/forage-subcustomer" : "/api/myagreements/forage";
	            var feedUrl = customerNumber.length > 0 ? "/api/myagreements/feed-subcustomer" : "/api/myagreements/feed";
	            var seedUrl = customerNumber.length > 0 ? "/api/myagreements/seed-subcustomer" : "/api/myagreements/seed";
	            var grainUrl = customerNumber.length > 0 ? "/api/myagreements/grain-subcustomer" : "/api/myagreements/grain";
	            var merchandiseUrl = customerNumber.length > 0 ? "/api/myagreements/merchandise-subcustomer" : "/api/myagreements/merchandise";

	            // If user goes to seed agreements with toggle activated, get articles from backend.
	            if (tab === "seed") {
	                var toggle = getUrlParameter("toggle");
	                var agreementNumber = toggle ? toggle.replace(/^\D+/g, '') : ''; // replace all leading non-digits with nothing

	                if (agreementNumber) {
	                    var url = customerNumber.length > 0 ? "/api/seedagreement/getconnectedseedagreements-subcustomer" : "/api/seedagreement/getconnectedseedagreements";
	                    var divId = "seed-child-agreements-" + agreementNumber;
	                    var totalQuantityDivId = "totalquantity-" + agreementNumber;

	                    $.ajax({
	                        type: "POST",
	                        url: url,
	                        cache: false,
	                        data: { agreementNumber: agreementNumber, pageId: currentPageId, acceptedQuantity: "", activeCustomerNumber: customerNumber},
	                        success: function (data) {
	                            if (data.length !== 0) {
	                                if (data.ModelString.length !== 0) {
	                                    $("#" + divId).html(data.ModelString);
	                                }
	                                if (data.TotalQuantity.length !== 0) {
	                                    $("#" + totalQuantityDivId).html(data.TotalQuantity + "  ton");
	                                }
	                                //$("#" + totalQuantityDivId).html("-");
	                            }
	                        },
	                        error: function (e) {
	                            console.log("Something went wrong with the AJAX request!");
	                            console.log(e.responseText);
	                        }
	                    });
	                }

	                // Get all connected agreements in the background
	                var seedAgreementsCommaSeparatedList = $("#SeedAgreementsCommaSeparatedList").val();

	                if (seedAgreementsCommaSeparatedList.length !== 0) {
	                    var stringArray = seedAgreementsCommaSeparatedList.split(",");
	                    var seedConnectedAgreementsUrl = customerNumber.length > 0 ? "/api/seedagreement/getconnectedseedagreements-subcustomer" : "/api/seedagreement/getconnectedseedagreements";

	                    for (var i = 0; i < stringArray.length; i++) {
	                        // Trim the excess whitespace.
	                        stringArray[i] = stringArray[i].replace(/^\s*/, "").replace(/\s*$/, "");
	                        var agreement = stringArray[i];
	                        var acceptedQuantity = $("#AcceptedQuantity-" + agreement).val();

	                        $.ajax({
	                            type: "POST",
	                            url: seedConnectedAgreementsUrl,
	                            cache: false,
	                            data: { agreementNumber: agreement, pageId: currentPageId, acceptedQuantity: acceptedQuantity, activeCustomerNumber: customerNumber },
	                            success: function (data) {
	                                // Only for caching purpose in the background
	                            },
	                            error: function (e) {
	                                console.log("Something went wrong with the AJAX request!");
	                                console.log(e.responseText);
	                            }
	                        });
	                    }
	                }
	            }

	            if (tab !== "grain") {
	                requests.push($.ajax({
	                    type: "POST",
	                    url: grainUrl,
	                    cache: false,
	                    data: { pageId: currentPageId, activeCustomerNumber: customerNumber },
	                    success: function (data) {
	                        if (data.length !== 0) {
	                            if (data.ModelString.length !== 0) {
	                                $("#grainDiv").replaceWith(data.ModelString);
	                            }
	                        }
	                    },
	                    error: function (e) {
	                        console.log("Something went wrong with the AJAX request!");
	                        console.log(e.responseText);
	                    }
	                }));
	            }

	            if (tab !== "seed") {
	                requests.push($.ajax({
	                    type: "POST",
	                    url: seedUrl,
	                    cache: false,
	                    data: { pageId: currentPageId, activeCustomerNumber: customerNumber },
	                    success: function (data) {
	                        if (data.length !== 0) {
	                            if (data.ModelString.length !== 0) {
	                                $("#seedDiv").html(data.ModelString);
	                            }
	                            if (data.AgreementsCommaseparatedList) {
	                                // Make sure to run all the calls for getting connected agreements so everything is cached, otherwise the performance will be insufficient
	                                var stringArray = data.AgreementsCommaseparatedList.split(",");
	                                var url = "/api/seedagreement/getconnectedseedagreements";
	                                var currentPageId = $("#CurrentPageId").val();

	                                for (var i = 0; i < stringArray.length; i++) {
	                                    // Trim the excess whitespace.
	                                    stringArray[i] = stringArray[i].replace(/^\s*/, "").replace(/\s*$/, "");

	                                    var agreementNumber = stringArray[i];
	                                    var acceptedQuantity = $("#AcceptedQuantity-" + agreementNumber).val();

	                                    $.ajax({
	                                        type: "POST",
	                                        url: url,
	                                        cache: false,
	                                        data: { agreementNumber: agreementNumber, pageId: currentPageId, acceptedQuantity: acceptedQuantity },
	                                        success: function (data) {
	                                            // Only for caching purpose in the background
	                                        },
	                                        error: function (e) {
	                                            console.log("Something went wrong with the AJAX request!");
	                                            console.log(e.responseText);
	                                        }
	                                    });
	                                }
	                            }
	                        }
	                    },
	                    error: function (e) {
	                        console.log("Something went wrong with the AJAX request!");
	                        console.log(e.responseText);
	                    }
	                }));
	            }

	            if (tab !== "forage") {
	                requests.push($.ajax({
	                    type: "POST",
	                    url: forageUrl,
	                    cache: false,
	                    data: { pageId: currentPageId, activeCustomerNumber: customerNumber },
	                    success: function (data) {
	                        if (data.length !== 0) {
	                            if (data.ModelString.length !== 0) {
	                                $("#foragediv").html(data.ModelString);
	                            }
	                        }
	                    },
	                    error: function (e) {
	                        console.log("Something went wrong with the AJAX request!");
	                        console.log(e.responseText);
	                    }
	                }));
	            }

	            if (tab !== "feed") {
	                requests.push($.ajax({
	                    type: "POST",
	                    url: feedUrl,
	                    cache: false,
	                    data: { pageId: currentPageId, activeCustomerNumber: customerNumber },
	                    success: function (data) {
	                        if (data.length !== 0) {
	                            if (data.ModelString.length !== 0) {
	                                $("#feedagreements").html(data.ModelString);
	                            }
	                        }
	                    },
	                    error: function (e) {
	                        console.log("Something went wrong with the AJAX request!");
	                        console.log(e.responseText);
	                    }
	                }));
	            }

	            if (tab !== "merchandise") {
	                requests.push($.ajax({
	                    type: "POST",
	                    url: merchandiseUrl,
	                    cache: false,
	                    data: { pageId: currentPageId, activeCustomerNumber: customerNumber },
	                    success: function (data) {
	                        if (data.length !== 0) {
	                            if (data.ModelString.length !== 0) {
	                                $("#tradingagreements").html(data.ModelString);
	                            }
	                        }
	                    },
	                    error: function (e) {
	                        console.log("Something went wrong with the AJAX request!");
	                        console.log(e.responseText);
	                    }
	                }));
	            }
			}
        }

        var loaderWrapper = '<div class="loader-wrapper"><div class="loader"></div></div>';
        $(".customer-number-dropdown").on("change", function () {
            $.each(requests, function (index, request) {
                request.abort();
            });
            requests = [];
            var selectedCustomerNumber = $(this).val();
            $('#CurrentCustomerNumber').val(selectedCustomerNumber); // update hidden input to keep track of selected customer no
            $(".js-tab").data("extra-data-key", "customerNumber");
            $(".js-tab").data("extra-data-value", selectedCustomerNumber);
            gro.modules.url.addUrlParam(document.location.search, "customerNumber", selectedCustomerNumber);
            $("#grainDiv").html(loaderWrapper);
            $("#seedagreements").html(loaderWrapper);
            $("#foragediv > .layout__item:first").html(loaderWrapper);
            $("#tradingagreements").html(loaderWrapper);
            $("#feedagreements").html(loaderWrapper);
            var grainUrl = "/api/myagreements/grain-subcustomer";
            var forageUrl = "/api/myagreements/forage-subcustomer";
            var feedUrl = "/api/myagreements/feed-subcustomer";
            var merchandiseUrl = "/api/myagreements/merchandise-subcustomer";
            var seedUrl = "/api/myagreements/seed-subcustomer";

            var currentPageId = $("#CurrentPageId").val();
            requests.push($.ajax({
                type: "POST",
                url: grainUrl,
                cache: false,
                data: { pageId: currentPageId, activeCustomerNumber: selectedCustomerNumber },
                success: function (data) {
                    if (data.length !== 0) {
                        if (data.ModelString.length !== 0) {
                            $("#grainDiv").replaceWith(data.ModelString);
                        }
                    }
                },
                error: function (e) {
                    console.log("Something went wrong with the AJAX request!");
                    console.log(e.responseText);
                }
            }));
            requests.push($.ajax({
                type: "POST",
                url: forageUrl,
                cache: false,
                data: { pageId: currentPageId, activeCustomerNumber: selectedCustomerNumber },
                success: function (data) {
                    if (data.length !== 0) {
                        if (data.ModelString.length !== 0) {
                            $("#foragediv").html(data.ModelString);
                        }
                    }
                },
                error: function (e) {
                    console.log("Something went wrong with the AJAX request!");
                    console.log(e.responseText);
                }
            }));
            requests.push($.ajax({
                type: "POST",
                url: feedUrl,
                cache: false,
                data: { pageId: currentPageId, activeCustomerNumber: selectedCustomerNumber },
                success: function (data) {
                    if (data.length !== 0) {
                        if (data.ModelString.length !== 0) {
                            $("#feedagreements").html(data.ModelString);
                        }
                    }
                },
                error: function (e) {
                    console.log("Something went wrong with the AJAX request!");
                    console.log(e.responseText);
                }
            }));
            requests.push($.ajax({
                type: "POST",
                url: merchandiseUrl,
                cache: false,
                data: { pageId: currentPageId, activeCustomerNumber: selectedCustomerNumber },
                success: function (data) {
                    if (data.length !== 0) {
                        if (data.ModelString.length !== 0) {
                            $("#tradingagreements").html(data.ModelString);
                        }
                    }
                },
                error: function (e) {
                    console.log("Something went wrong with the AJAX request!");
                    console.log(e.responseText);
                }
            }));
            requests.push($.ajax({
                type: "POST",
                url: seedUrl,
                cache: false,
                data: { pageId: currentPageId, activeCustomerNumber: selectedCustomerNumber },
                success: function (data) {
                    if (data.length !== 0) {
                        if (data.ModelString.length !== 0) {
                            $("#seedDiv").html(data.ModelString);
                        }
                        if (data.AgreementsCommaseparatedList) {
                            // Make sure to run all the calls for getting connected agreements so everything is cached, otherwise the performance will be insufficient
                            var stringArray = data.AgreementsCommaseparatedList.split(",");
                            var url = "/api/seedagreement/getconnectedseedagreements-subcustomer";
                            var currentPageId = $("#CurrentPageId").val();

                            for (var i = 0; i < stringArray.length; i++) {
                                // Trim the excess whitespace.
                                stringArray[i] = stringArray[i].replace(/^\s*/, "").replace(/\s*$/, "");

                                var agreementNumber = stringArray[i];
                                var acceptedQuantity = $("#AcceptedQuantity-" + agreementNumber).val();

                                $.ajax({
                                    type: "POST",
                                    url: url,
                                    cache: false,
                                    data: { agreementNumber: agreementNumber, pageId: currentPageId, acceptedQuantity: acceptedQuantity, activeCustomerNumber: selectedCustomerNumber },
                                    success: function (data) {
                                        // Only for caching purpose in the background
                                    },
                                    error: function (e) {
                                        console.log("Something went wrong with the AJAX request!");
                                        console.log(e.responseText);
                                    }
                                });
                            }
                        }
                    }
                },
                error: function (e) {
                    console.log("Something went wrong with the AJAX request!");
                    console.log(e.responseText);
                }
            }));
        });

        $(document).on("click", ".showAnalyze", function () {
            var url = $("#CurrentCustomerNumber").val().length > 0 ?
                "/api/agreement/farmsample-subcustomer/" + $(this).attr("data-id").toString() + "/" + $("#CurrentCustomerNumber").val() + "/" + $("#isInternal").val() :
                "/api/agreement/farmsample/" + $(this).attr("data-id").toString() + "/" + $("#isInternal").val();
            $.ajax({
                dataType: "html",
                url: url,
                success: function (data) {
                    bindData(data);
                },
                error: function (e) {
                    console.log(e.responseText);
                    modal.fadeOut();
                }
            });

            modal.fadeIn();

            return false;
        });

        $(document.body).on("click", ".showPriceHedging", function () {
            var url = $("#CurrentCustomerNumber").val().length > 0 ?
                "/api/agreement/price-hedging-subcustomer/" + $(this).attr("data-id").toString() + "/" + $("#CurrentCustomerNumber").val() + "/" + $("#isInternal").val() :
                "/api/agreement/price-hedging/" + $(this).attr("data-id").toString() + "/" + $("#isInternal").val();

            $.ajax({
                dataType: "html",
                url: url,
                success: function (data) {
                    bindData(data);
                },
                error: function (e) {
                    console.log(e.responseText);
                    modal.fadeOut();
                }
            });

            modal.fadeIn();

            return false;
        });

        $(".showWeighInMoreInfo").on("click", function () {
            var url = "/api/weigh-in/more-info/" + $(this).attr("data-id").toString() + "/" + $("#isInternal").val();
            url += "?date=" + encodeURIComponent($(this).attr("data-date")) + "&sort=" + encodeURIComponent($(this).attr("data-sort"));
            $.ajax({
                dataType: "html",
                url: url,
                success: function (data) {
                    bindData(data);
                },
                error: function () {
                    modal.fadeOut();
                }
            });

            modal.fadeIn();

            return false;
        });

        $(".showWeighInAnalyze").on("click", function () {
            var url = "/api/weigh-in/analyze/" + $(this).attr("data-id").toString() + "/" + $("#isInternal").val();
            var activeCustomerNumber = $(this).data("activecustomer");
            //url += "?date=" + encodeURIComponent($(this).attr("data-date")) + "&sort=" + encodeURIComponent($(this).attr("data-sort"));
            $.ajax({
                dataType: "html",
                url: url,
                data: { activeCustomerNumber: activeCustomerNumber },
                success: function (data) {
                    if (data.indexOf("<html>") > 0)
                        window.location.href = "/";
                    else
                        bindData(data);
                },
                error: function () {
                    modal.fadeOut();
                }
            });
            modal.fadeIn();
            return false;
        });

        $(".js-load-weigh-in-analysis").on("click", function () {
            var control = $(this);
            var url = "/api/weigh-in/analyze/" + $(this).attr("data-id").toString() + "/" + $("#isInternal").val();

            $.ajax({
                dataType: "html",
                url: url,
                success: function (data) {
                    if (data.indexOf("<html>") > 0) {
                        window.location.href = "/";
                    } else {
                        var collapseTarget = control.next(".collapse__target");
                        var loadingIcon = collapseTarget.find(".loader-wrapper");
                        var collapseContent = collapseTarget.find(".collapse__target-content");

                        collapseContent.html(data);
                        loadingIcon.fadeOut();
                    }
                },
                error: function () {
                }
            });
        });

        $(document).on('change', '.js-show-harvest-year', function () {
            var currentPageId = $("#CurrentPageId").val();
            var agreementNumber = $("#ForageAgreementNumber").val();
            var selectedId = $("#SelectedHarvestYear").val();
            var customerNumber = $("#CurrentCustomerNumber").val();

            var url = "/api/forageagreement/getharvestyeardata";

            $.ajax({
                type: "GET",
                url: url,
                cache: false,
                data: { selectedvalue: selectedId, pageId: currentPageId, agreementNumber: agreementNumber, customerNumber: customerNumber },
                success: function (data) {
                    $("#harvestyear").html(data);
                },
                error: function (e) {
                    console.log("Something went wrong with the AJAX request!");
                    console.log(e.responseText);
                }
            });
        });

        $(document).on('change', '.seedagreements-dropdown', function () {
            var selectedValue = $("#SelectedHarvestYear").val();
            var currentPageId = $("#CurrentPageId").val();
            var currentCustomerNumber = $("#CurrentCustomerNumber").val();
            var url = currentCustomerNumber.length > 0 ? "/api/seedagreement/getseedagreements-subcustomer" : "/api/seedagreement/getseedagreements";
            var spinner = $("#harvest-year-spinner");

            spinner.addClass("is-visible");

            $.ajax({
                type: "POST",
                url: url,
                cache: false,
                data: { selectedvalue: selectedValue, pageId: currentPageId, activeCustomerNumber: currentCustomerNumber },
                success: function (data) {
                    if (data && data.ModelString) {
                        $("#seedagreements").html(data.ModelString);
                        gro.modules.url.addUrlParam(document.location.search, "year", selectedValue);
                    }
                },
                error: function (e) {
                    console.log("Something went wrong with the AJAX request!");
                    console.log(e.responseText);
                },
                complete: function () {
                    spinner.removeClass("is-visible");
                }
            });
        });

        $('.my-agreements__provnr-link').bind('click', function () {
            var url = "/api/forageagreement/getanalysisresults";
            var id = ($(this).attr('id'));
            $('.my-agreements__sample-list-item a.is-active').removeClass('is-active');
            $(this).addClass("is-active");

            $.ajax({
                type: "POST",
                url: url,
                cache: false,
                data: { provnr: id },
                success: function (data) {
                    if (data.length !== 0) {
                        if (data.ModelString.length !== 0) {
                            $("#analysisresultsdiv").html(data.ModelString);
                        }
                        if (data.ProvNr.length !== 0) {
                            $("#certnrheading").html(data.ProvNr);
                        }
                    }
                },
                error: function (e) {
                    console.log("Something went wrong with the AJAX request!");
                    console.log(e.responseText);
                }
            });
        });

        $(document).on('click', '.seedagreeements', function () {
            var hasLoaded = $(this).hasClass("has-loaded");
            var button = this;

            if (!hasLoaded) {
                var currentCustomerNumber = $("#CurrentCustomerNumber").val();
                var url = currentCustomerNumber.length > 0 ? "/api/seedagreement/getconnectedseedagreements-subcustomer" : "/api/seedagreement/getconnectedseedagreements";
                var agreementNumber = ($(this).attr('id'));
                var currentPageId = $("#CurrentPageId").val();
                var acceptedQuantity = $("#AcceptedQuantity-" + agreementNumber).val();
                var divId = "seed-child-agreements-" + agreementNumber;
                var totalQuantityDivId = "totalquantity-" + agreementNumber;
                var toggleTarget = $(this).data("toggle-target");

                $(toggleTarget).addClass("is-loading");

                $.ajax({
                    type: "POST",
                    url: url,
                    cache: false,
                    data: { agreementNumber: agreementNumber, pageId: currentPageId, acceptedQuantity: acceptedQuantity, activeCustomerNumber: currentCustomerNumber },
                    success: function (data) {
                        if (data.length !== 0) {
                            if (data.ModelString.length !== 0) {
                                $("#" + divId).html(data.ModelString);
                            }
                            if (data.TotalQuantity.length !== 0) {
                                $("#" + totalQuantityDivId).html(data.TotalQuantity + "  ton");
                            }
                            //$("#" + totalQuantityDivId).html("-");
                            $(button).addClass("has-loaded");
                        }
                    },
                    error: function (e) {
                        console.log("Something went wrong with the AJAX request!");
                        console.log(e.responseText);
                    },
                    complete: function () {
                        $(toggleTarget).removeClass("is-loading");
                    }
                });
            }
            else {
                $(button).removeClass("has-loaded");
            }
        });

        $(document).on('click', '.feedagreements', function () {
            var hasLoaded = $(this).hasClass("has-loaded");
            var button = this;

            if (!hasLoaded) {
                var currentCustomerNumber = $("#CurrentCustomerNumber").val();
                var url = "/api/feedagreement/getfeedagreementarticles";
                var agreementNumber = ($(this).attr('id'));
                var currentPageId = $("#CurrentPageId").val();
                var unit = $(button).find(".js-unit").val();
                var divId = "feedagreementarticles-" + agreementNumber;
                var toggleTarget = $(this).data("toggle-target");

                $(toggleTarget).addClass("is-loading");

                $.ajax({
                    type: "POST",
                    url: url,
                    cache: false,
                    data: { agreementNumber: agreementNumber, pageId: currentPageId, unit: unit, activeCustomerNumber: currentCustomerNumber },
                    success: function (data) {
                        if (data) {
                            if (data.length !== 0) {
                                if (data.ModelString.length !== 0) {
                                    $("#" + divId).html(data.ModelString);
                                    $(button).addClass("has-loaded");
                                }
                            }
                        }
                    },
                    error: function (e) {
                        console.log("Something went wrong with the AJAX request!");
                        console.log(e.responseText);
                    },
                    complete: function () {
                        $(toggleTarget).removeClass("is-loading");
                    }
                });
            } else {
                $(button).removeClass("has-loaded");
            }
        });

        $(document).on('click', '.tradingagreements', function () {
            var hasLoaded = $(this).hasClass("has-loaded");
            var button = this;

            if (!hasLoaded) {
                var currentCustomerNumber = $("#CurrentCustomerNumber").val();
                var url = currentCustomerNumber.length > 0 ? "/api/tradingagreement/gettradingagreementarticles-subcustomer" : "/api/tradingagreement/gettradingagreementarticles";
                var agreementNumber = ($(this).attr('id'));
                var unit = $(button).find(".js-unit").val();
                var divId = "tradingagreementarticles-" + agreementNumber;
                var hiddenId = "agreementtype-" + agreementNumber;
                var agreementType = $("#" + hiddenId).val();
                var toggleTarget = $(this).data("toggle-target");

                $(toggleTarget).addClass("is-loading");

                $.ajax({
                    type: "POST",
                    url: url,
                    cache: false,
                    data: { agreementNumber: agreementNumber, agreementType: agreementType, activeCustomerNumber: currentCustomerNumber },
                    success: function (data) {
                        if (data) {
                            if (data.length !== 0) {
                                if (data.ModelString.length !== 0) {
                                    var dataWithUnit = data.ModelString.replace(/{{:unit}}/g, unit);
                                    $("#" + divId).html(dataWithUnit);
                                    $(button).addClass("has-loaded");
                                }
                            }
                        }
                    },
                    error: function (e) {
                        console.log("Something went wrong with the AJAX request!");
                        console.log(e.responseText);
                    },
                    complete: function () {
                        $(toggleTarget).removeClass("is-loading");
                    }
                });
            } else {
                $(button).removeClass("has-loaded");
            }
        });

        $(document).on('change', '.feedagreements-dropdown', function () {
            var selectedValue = $("#agreementtype").val();
            var currentCustomerNumber = $("#CurrentCustomerNumber").val();
            var url = currentCustomerNumber.length > 0 ? "/api/feedagreement/getfeedagreementscurrentorinactive-subcustomer" : "/api/feedagreement/getfeedagreementscurrentorinactive";
            var currentPageId = $("#CurrentPageId").val();

            $.ajax({
                type: "POST",
                url: url,
                cache: false,
                data: { selectedvalue: selectedValue, pageId: currentPageId, activeCustomerNumber: currentCustomerNumber },
                success: function (data) {
                    if (data.length !== 0) {
                        if (data.ModelString.length !== 0) {
                            $("#feedagreements").html(data.ModelString);
                        }
                    }
                },
                error: function (e) {
                    console.log("Something went wrong with the AJAX request!");
                    console.log(e.responseText);
                }
            });
        });

        $(document).on('change', '.tradingagreements-dropdown', function () {
            var selectedValue = $("#tradingagreementtype").val();
            var currentCustomerNumber = $("#CurrentCustomerNumber").val();
            var url = currentCustomerNumber.length > 0 ? "/api/tradingagreements/gettradingagreementscurrentorinactive-subcustomer" : "/api/tradingagreements/gettradingagreementscurrentorinactive";
            var currentPageId = $("#CurrentPageId").val();

            $.ajax({
                type: "POST",
                url: url,
                cache: false,
                data: { selectedvalue: selectedValue, pageId: currentPageId, activeCustomerNumber: currentCustomerNumber },
                success: function (data) {
                    if (data.length !== 0) {
                        if (data.ModelString.length !== 0) {
                            $("#tradingagreements").html(data.ModelString);
                        }
                    }
                },
                error: function (e) {
                    console.log("Something went wrong with the AJAX request!");
                    console.log(e.responseText);
                }
            });
        });
    });
});
